import { type SanityColor } from '@data/sanity/queries/types/modules'

export const backgroundColorClasses: Record<SanityColor, string> = {
  'gray-light': 'bg-gray-light text-green-dark',
  gray: 'bg-gray text-green-dark',
  'green-dark': 'bg-green-dark text-yellow',
  yellow: 'bg-yellow text-green-dark',
}
